import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Instagram, Facebook } from "lucide-react";

const LOGO = "/logo.png";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-border py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src={LOGO} alt="logo" className="h-10 w-auto" />
          <div className="text-xs text-muted-foreground">{t.footer.tagline}</div>
        </div>
        <div className="flex items-center gap-3">
          <a href="https://www.instagram.com/floresonthemove/" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full border border-border hover:border-primary hover:text-primary transition-colors">
            <Instagram className="h-4 w-4" />
          </a>
          <a href="https://facebook.com/FloresOnTheMoveUS" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full border border-border hover:border-primary hover:text-primary transition-colors">
            <Facebook className="h-4 w-4" />
          </a>
        </div>
        <div className="text-xs text-muted-foreground">© {new Date().getFullYear()} Flores On The Move LLC. {t.footer.rights}</div>
      </div>
    </footer>
  );
}
